import React from "react";
import { useSearchParams } from "react-router-dom";

export default function AvailabilityFilter() {
    const [searchParams, setSearchParams] = useSearchParams();

    // Parse the "grades" query parameter from the URL
    const selectedAvailability = searchParams.get('availability') ? searchParams.get('availability'):'false';

    // Function to handle checkbox clicks
    const handleAvailabilityChange = () => {
        let availability = selectedAvailability === 'false';
        if(availability){
            searchParams.set('availability', availability );
        } else  searchParams.delete('availability');
        setSearchParams(searchParams);
    };


    return (
        <div className='category-container'>
            <h2 className='text-lg text-primary font-semibold'>Availability :</h2>
            <hr/>
            <div className='mt-2'>
                <label className='category-item'>
                    <input className='h-4' type="checkbox" name="availabilty"  checked={selectedAvailability === 'false'}
                           onChange={() => handleAvailabilityChange()} /> Include Out of Stock
                </label>
            </div>
        </div>
    );
}
